export const TennisSymbols = {
    ContractAccess: Symbol.for("LTContractAccess")
}